import React, { memo } from "react";
import PropTypes from "prop-types";
import Section from "../../common/Section";
import Table from "../../common/Table";
import { Popup } from 'semantic-ui-react';
import CheckBoxWithChild from "../../common/CheckBoxWithChild";

const InfrastructuurAddFormTable = (props) => {
    const {
        zoekModels,
        infrastructuren,
        onChange,
        totaalAantalZoekResultaten
    } = props;

    function returnTdContent(text) {
        return text && text.length > 40 ? <Popup wide="very" position="top left" trigger={<p>{text.substring(0, 40) + "..."}</p>} content={text} /> : text ? text : "";
    }

    const tdStyle = { 'border': '1px', 'borderStyle': 'solid', 'borderColor': '#eeefef', 'paddingBottom': '2px', 'paddingTop': '2px', 'paddingLeft': '2px', 'paddingRight': '5px' };

    const rows = zoekModels.map((infrastructuur, i) => {
        const infrastructurenInDomein = zoekModels.filter(i => i.domeinId === infrastructuur.domeinId);
        const showFirstColumn = infrastructurenInDomein.findIndex(i => i.id === infrastructuur.id) === 0;
        const behoortInfrastructuurAlTotSportclub = infrastructuren.findIndex(i => i.id === infrastructuur.id) !== -1;
        const isAangevinktVoorSportclub = infrastructuren.filter(i => i.id === infrastructuur.id).length > 0 ? infrastructuren.filter(i => i.id === infrastructuur.id)[0].deelVanSportclub : false;
        const domeinInSportclub = infrastructuren.filter(i => i.domeinId === infrastructuur.domeinId).length > 0;
        const domeinAangevinktInSportclub = infrastructuren.filter(i => i.domeinId === infrastructuur.domeinId && i.deelVanSportclub).length > 0;
        return (<tr style={{ borderStyle: 'solid', borderWidth: "1px", borderColor: '#eeefef', height: '10px' }} key={i}>
            {showFirstColumn ? <td style={tdStyle}><CheckBoxWithChild disabled={domeinInSportclub} name={"domeinDeelVanSportclub_" + infrastructuur.domeinId} value={domeinAangevinktInSportclub || infrastructuur.domeinDeelVanSportclub} label={returnTdContent(infrastructuur.domeinNaam)} onChange={onChange} /></td> : <td style={tdStyle} />}
            <td style={tdStyle}><CheckBoxWithChild disabled={behoortInfrastructuurAlTotSportclub} name={"deelVanSportclub_" + i} value={behoortInfrastructuurAlTotSportclub ? isAangevinktVoorSportclub : infrastructuur.deelVanSportclub} label={returnTdContent(infrastructuur.infrastructuurNaam)} onChange={onChange} /></td>
            <td style={tdStyle}>{returnTdContent(infrastructuur.adres)}</td>
        </tr>);
    });

    return rows && rows.length > 0 ?
        <Section style={{marginTop: '0px'}}>
            <Table headers={["Sportdomein", "Sportinfrastructuur", "Adres"]}>
                {rows}
            </Table>
            {totaalAantalZoekResultaten < 100 || <p style={{ margin: "15px 0" }}>Meer dan 100 zoekresultaten gevonden, verfijn je zoekcriteria.</p>}
        </Section> : totaalAantalZoekResultaten === 0 ? <p style={{ margin: "15px 0" }}>Geen infrastructuren gevonden die voldoen aan de opgegeven zoekcriteria.</p> : null;
};

InfrastructuurAddFormTable.propTypes = {
    zoekModels: PropTypes.array,
    infrastructuren: PropTypes.array,
    onChange: PropTypes.func,
    totaalAantalZoekResultaten: PropTypes.number
};

export default memo(InfrastructuurAddFormTable);